import cx from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Translation } from 'react-i18next';

const propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  closeText: PropTypes.string,
  closeButtonClassName: PropTypes.string,
  cancelText: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

const defaultProps = {
  content: '',
  cancelText: null,
  title: '',
  onClose() {},
  onCancel() {},
};

class BasicModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { onClose } = this.props;
    onClose();
  }

  render() {
    const { title, content, closeText, cancelText, onCancel, closeButtonClassName } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className="Container Container--max-xxs">
            <div className="Card Card--pop align-center box-6x">
              {title && (
                <h4 className="space-2x" data-testid="basic-modal-title">
                  <strong>{title}</strong>
                </h4>
              )}
              <p
                className="space-4x"
                data-testid="basic-modal-content"
                style={{
                  wordBreak: 'break-all',
                }}
              >
                {typeof content === 'string' ? (
                  content.split('\n').map((partOfTheMessage, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <span key={index}>
                      {partOfTheMessage}
                      <br />
                    </span>
                  ))
                ) : (
                  <span>{content}</span>
                )}
              </p>
              {cancelText && (
                <button
                  className="Btn Btn--bold-mobile"
                  data-testid="basic-modal-cancel-button"
                  type="button"
                  onClick={onCancel}
                >
                  {cancelText}
                </button>
              )}
              <button
                className={cx('Btn Btn--primary Btn--bold-mobile', closeButtonClassName)}
                data-testid="basic-modal-close-button"
                type="button"
                onClick={this.handleClose}
              >
                {closeText || t('Global-confirm')}
              </button>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

BasicModal.propTypes = propTypes;
BasicModal.defaultProps = defaultProps;

export default BasicModal;
